export default (previousState = false, { type }) => {
    if (type === 'THM0') {
        return !previousState;
    }
    return previousState;
};
